import { Icons } from "components";
import { MISSION_GOAL } from "utils/constants/options";

export const renderMissionType = (value, color) => {
  switch (value) {
    case "step":
      return { label: "ก้าว", icon: <Icons.Shoe color={color} width="22" height="22" /> };
    case "mission_move":
      return { label: "ขยับร่างกาย", icon: <Icons.Dumbell color={color} width="22" height="22" /> };
    case "mission_eye":
      return { label: "ผ่อนคลายสายตา", icon: <Icons.EmojiSleep color={color} width="22" height="22" /> };
    default:
      return { label: value, icon: null };
  }
};

export const renderCompetitionFormat = (value, color) => {
  switch (value) {
    case "department":
      return { label: "แบบแผนก", icon: <Icons.Building3 color={color} width="22" height="22" /> };
    case "team":
      return { label: "แบบแบ่งทีม", icon: <Icons.PeopleGroup color={color} width="22" height="22" /> };
    default:
      return { label: value, icon: null };
  }
};

export const getTargetUnitLabel = (missionTypeValue) => {
  switch (missionTypeValue) {
    case "step":
      return "ก้าว";
    case "mission_move":
    case "mission_eye":
      return "ครั้ง";
    default:
      return "";
  }
};

export const getAccumulatedLabelEn = (missionGoal, category) => {
  if (missionGoal === MISSION_GOAL.HIGHEST_SCORE.value) {
    return "Top Score";
  }
  switch (category) {
    case "step":
      return "Total Steps";
    case "mission_move":
    case "mission_eye":
      return "Total Reps";
    default:
      return "Total Steps";
  }
};
